import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { listWorkflowRunsAsync } from '../infrastructure/httpclient';
import { useSnackbar } from 'notistack';
import { useAuth } from '../context/AuthContext';

const WorkflowRunsPage = () => {
  const { user, token } = useAuth();
  const { workflowName } = useParams();
  const [runs, setRuns] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRuns, setTotalRuns] = useState(0);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    listWorkflowRunsAsync(token, workflowName, page + 1, rowsPerPage)
      .then((response) => {
        setRuns(response.data.items);
        setTotalRuns(response.data.total_count);
      })
      .catch((error) => {
        console.error("Failed to fetch runs:", error);
        enqueueSnackbar('Failed to load runs', { variant: 'error' });
      });
  }, [workflowName, enqueueSnackbar, user?.email, page, rowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Runs for {workflowName} workflow.
      </Typography>

      {totalRuns === 0 ? (
        <Paper sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="body1" color="text.secondary">
            No runs available for this workflow.
          </Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ p: { xs: 1, sm: 2 }, width: { xs: 'auto', sm: '15%' } }}>When</TableCell>
                <TableCell sx={{ p: { xs: 1, sm: 2 }, width: { xs: 'auto', sm: '15%' } }}>Status</TableCell>
                <TableCell sx={{ p: { xs: 1, sm: 2 }, width: { xs: 'auto', sm: '70%' } }}>Outcome</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {runs.map((run) => (
                <TableRow key={run.id}>
                  <TableCell sx={{ p: { xs: 1, sm: 2 }, wordBreak: 'break-word' }}>
                    {new Date(run.startat_utc).toLocaleString()}
                  </TableCell>
                  <TableCell sx={{ p: { xs: 1, sm: 2 }, wordBreak: 'break-word' }}>{run.failed ? "FAILED" : "SUCCEEDED"}</TableCell>
                  <TableCell sx={{ p: { xs: 1, sm: 2 }, wordBreak: 'break-word' }}>{run.result}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRuns}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      )}
    </Container>
  );

};

export default WorkflowRunsPage;